// import React, {Component} from 'react';
// import {
//     BackHandler,
//     View,
//     FlatList,
//     ScrollView,
//     TouchableOpacity,
//     Image,
//     Switch,
//     Platform,
//     KeyboardAvoidingView
// } from "react-native"
// import Colors from "../../tools/Colors";
// import {moderateScale} from "../../tools/Scaling";
// import NavigationService from "../../redux/actions/NavigationService";
// import HMTextView from "../../customviews/HMTextView";
// import {Icon} from "native-base";
// import styles from "../../styles/SlideMenuStyle";
// import HMItem from "../../customviews/HMItem";
// import i18n from '../../I18n/i18n.js';
// import Constants from "../../tools/Constants";
// import {serviceActionSelectCategory} from "../../redux/actions/ActionMenuScreen";
// import connect from "react-redux/es/connect/connect";
// import {Tools} from "../../tools/Tools";
// import {DialogLoadingCustomize} from "../../tools/DialogLoadingCustomize";
// import {AsyngStorageClass} from "../../tools/AsyngStorageClass";
// import {urlGetAllData} from "../../tools/Constants";
// import {TypeGetAllData} from "../../tools/Constants";
// import store from "../../redux/store";
// import {serviceActionSetState, serviceActionSetToken} from "../../redux/actions/ActionSplashGetAllData";
//
// export default class MenuDrawer extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             data: ["1", "2", "3"],
//             switchValue: false,
//
//             pending: false,
//             success: false,
//             error: ''
//         };
//
//     }
//
//     componentWillReceiveProps(propss) {
//
//     }
//
//     setData() {
//         let token = this.props.DataSplashScreen.token
//         this.props.callService(typeExport.urlMenuDrawer, `?notify_status=${this.state.switchValue}&token=${token}`, typeExport.TypeSetMenuDrawer, 'POST', token)
//         // this.props.callService(urlGetAllData, `?lang=fa&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xOTIuMTY4LjEuNDo4MDAwXC9hcGlcL2xvZ2luIiwiaWF0IjoxNTYxMzg4ODMwLCJleHAiOjE1NjEzOTI0MzAsIm5iZiI6MTU2MTM4ODgzMCwianRpIjoiSUlaWHZhdGVibjdFWXVzRCIsInN1YiI6MywicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSJ9.o0KBrCIT25CGALibOQwiomiDzVVX7D9ensRGPsOCznY`, TypeGetAllData, 'POST', token)
//
//     }
//
//     toggleSwitch = (value) => {
//         //onValueChange of the switch this function will be called
//         this.setState({switchValue: value},
//             () => {
//                 this.setData()
//
//             }
//         )
//
//         //Tools.Request(typeExport.POST, "", '', '', '', this.setState({switchValue: value,success:true,result}), '')
//         //state changes according to switch
//         //which will result in re-render the text
//     }
//
//     render() {
//         let data_splash = store_data
//         return (
//             <View style={styles.container}>
//                 <ScrollView>
//
//                     {/*
//                     <HMItem icon={"md-person"} onPress={() => NavigationService.navigateParams("ProductList")} text={"احمد خلیلی"}/>
// */}
//                     <View style={{
//                         backgroundColor: Colors.colorPrimary,
//                         height: moderateScale(70),
//                         padding: moderateScale(8),
//
//                         justifyContent: "center",
//                         //    alignItems: "center"
//                     }}>
//
//                         <View style={{
//                             backgroundColor: Colors.colorPrimary,
//                             //  padding: moderateScale(8),
//                             flexDirection: 'row',
//                             // //justifyContent: "flex-end",
//                             alignItems: "flex-end",
//                             //  justifyContent: "flex-end",
//                             marginTop: Platform.OS === 'ios' ? typeExport.HeightStatusBar : 0
//                         }}>
//                             <HMIcon name={"md-person"} style={{
//                                 color: 'white',
//                                 // backgroundColor:'#eea900'
//                                 //textAlign: 'center',
//                                 //  alignSelf: 'center'
//
//                             }}/>
//
//                             <View style={{width: moderateScale(10)}}/>
//                             {
//                                 data_splash.token ?
//                                     <HMTextView text={store_data.user.name} style={{
//                                         color: Colors.white,
//                                         fontSize: moderateScale(14),
//
//                                         //  backgroundColor:'#ee0042'
//                                         //textAlign: 'center',
//                                         //alignSelf: 'center'
//                                     }}/>
//                                     :
//                                     <TouchableOpacity
//                                         onPress={() => {
//                                             store.dispatch(serviceActionSetState({type: "MainScreen"}))
//                                             NavigationService.navigateParams('LoginStack')
//                                         }}
//                                         style={{
//                                             width: moderateScale(120),
//                                             height: moderateScale(28),
//                                             backgroundColor: Colors.white,
//                                             borderRadius: moderateScale(6),
//                                             alignItems: 'center',
//                                             justifyContent: 'center'
//                                         }}>
//                                         <HMTextView
//                                             type={'bold'}
//                                             text={'ورود به حساب کاربری'} style={{
//                                             color: Colors.colorPrimary,
//                                             fontSize: moderateScale(11),
//                                             //  backgroundColor:'#ee0042'
//                                             //textAlign: 'center',
//                                             //alignSelf: 'center'
//                                         }}/>
//                                     </TouchableOpacity>
//
//
//                             }
//
//                         </View>
//                         {/*<View style={{
//                             backgroundColor: Colors.colorPrimary,
//                             //  padding: moderateScale(8),
//                             flexDirection: 'row',
//                             width: '100%',
//                             // //justifyContent: "flex-end",
//                             alignItems: "center"
//                         }}>
//                             <HMTextView text={i18n.t('ChangeLanguage.notification')} style={{
//                                 color: Colors.white,
//                                 fontSize: moderateScale(18),
//                                 textAlign: 'center',
//                                 alignSelf: 'center'
//                             }}/>
//
//                             <View style={{flex: 1}}/>
//                             <Switch
//                                 style={{transform: [{scaleX: Platform.OS === 'ios' ? .6 : .9}, {scaleY: Platform.OS === 'ios' ? .6 : .9}]}}
//                                 // style={{marginTop:30}}
//                                 onValueChange={this.toggleSwitch}
//                                 // value={this.state.switchValue}
//                                // value={this.props.DataSplashScreen.results.user.notify_status == 1}
//                                 value={true}
//                             />
//                         </View>*/}
//                     </View>
//
//                     <View style={{flex: 1, marginTop: moderateScale(6)}}>
//
//
//                         <HMItem icon={"user"} text={i18n.t('constant.My_profile')} navigateParams={() => {
//                             //  NavigationService.navigatereset('ProfileStack');
//                             // NavigationService.navigate('ProfileStack');
//                             // NavigationService.navigate('LoginStack');
//                             if (store_data.token != null) {
//
//                                 NavigationService.navigateParams('ProfileStack')
//
//                             } else {
//                                 store.dispatch(serviceActionSetState({type: "ProfileStack"}))
//
//                                 NavigationService.navigateParams('LoginStack')
//
//                             }
//                         }}/>
//                         <HMItem icon={"building"} text={i18n.t('constant.Municipality_Portal')} navigateParams={() => {
//                             this.props.navigation.navigate("SubmitRequestScreen", {type: 0});
//
//
//                         }}/>
//                         <HMItem icon={"info-circle"} text={i18n.t('constant.About_software')} navigateParams={() => {
//                             this.props.navigation.navigate("SatiaScreen", {type: 1});
//
//                         }}/>
//                         <HMItem icon={"language"} text={i18n.t('constant.language')} navigateParams={() => {
//                             //  NavigationService.navigatereset('ChangeLanguageScreen');
//                             // this.props.navigation.popToTop();
//                             this.props.navigation.navigate("ChangeLanguageScreen");
//                         }}/>
//
//                         {/*  <HMItem icon={"md-heart"} text={i18n.t('constant.myApplys')} navigateParams={() => {
//                             this.props.navigation.navigate("MyApplyScreen");
//
//                         }}/>*/}
//
//                         <HMItem icon={"sign-out"} text={i18n.t('MenuDrawer.sign')} navigateParams={() => {
//                             BackHandler.exitApp()
//                             // Tools.exitApp()
//                             // store.dispatch(serviceActionSetToken(null))
//                         }}/>
//
//
//                     </View>
//
//                 </ScrollView>
//                 {/*<View style={styles.footerContainer}>*/}
//                 {/*<TouchableOpacity onPress={() => {*/}
//                 {/*}} style={{*/}
//                 {/*margin: moderateScale(4),*/}
//
//                 {/*width: moderateScale(29),*/}
//                 {/*height: moderateScale(29),*/}
//                 {/*}}>*/}
//                 {/*<Image source={require("../../assets/img/instageram1.png")}*/}
//                 {/*style={{width: "100%", height: "100%",}}/>*/}
//                 {/*</TouchableOpacity>*/}
//
//                 {/*<TouchableOpacity onPress={() => {*/}
//                 {/*}} style={{*/}
//                 {/*margin: moderateScale(4),*/}
//
//                 {/*width: moderateScale(29),*/}
//                 {/*height: moderateScale(29),*/}
//                 {/*}}>*/}
//                 {/*<Image source={require("../../assets/img/telegram.png")}*/}
//                 {/*style={{width: "100%", height: "100%",}}/>*/}
//                 {/*</TouchableOpacity>*/}
//
//
//                 {/*<TouchableOpacity onPress={() => {*/}
//                 {/*}} style={{*/}
//                 {/*margin: moderateScale(4),*/}
//
//                 {/*width: moderateScale(29),*/}
//                 {/*height: moderateScale(29),*/}
//                 {/*}}>*/}
//
//                 {/*<Image source={require("../../assets/img/whatsapp.png")}*/}
//                 {/*style={{width: "100%", height: "100%",}}/>*/}
//                 {/*</TouchableOpacity>*/}
//
//
//                 {/*</View>*/}
//
//                 {
//                     this.props.isLoadingSet ?
//                         <DialogLoadingCustomize/>
//                         : null
//                 }
//             </View>
//         );
//     }
//
// }
//
// //
// // const mapStateToProps = (state) => {
// //
// //     return {
// //         data: state.reducerDetailRestaurantScreen,
// //
// //         // position: state.reducerMenuScreen.position,
// //         // id_category: state.reducerMenuScreen.id_category,
// //         // list_item_category: state.reducerMenuScreen.list_item_category,
// //
// //
// //     }
// // }
// // const mapDispatchToProps = dispatch => {
// //     return {
// //         callServiceSelectCategory: (pos, id, list) => dispatch(serviceActionSelectCategory(pos, id, list)),
// //     }
// // }
// // export default connect(mapStateToProps, mapDispatchToProps)(MenuDrawer);


import React, {Component} from 'react';
import {
    KeyboardAvoidingView,
    Text,
    Animated,
    View,
    FlatList,
    ScrollView,
    TouchableOpacity,
    Image,
    Switch,
    Platform,
    BackHandler, Clipboard
} from "react-native"

import Colors from "../../tools/Colors";
import {moderateScale} from "../../tools/Scaling";
import * as NavigationService from "../../redux/NavigationService";
import HMTextView from "../../customviews/HMTextView";
import styles from "../../styles/SlideMenuStyle";
import HMItem from "../../customviews/HMItem";
import i18n from '../../I18n/i18n.js';
import {Tools} from "../../tools/Tools";
import DialogLoadingCustomize from "../../customviews/DialogLoadingCustomize";
import MainScreen from "../../screens/137/main/MainScreen";
import store from "../../redux/store";
//import ParentScreen from "../../ParentScreen";
import {typeExport} from "../../redux/store/type";
import HMIcon from "../../customviews/HMIcon";
import {
    serviceActionSetState,
    serviceActionSetNameDynamic
} from "../../screens/137/splash/action/ActionSplashGetAllData";

import {ToggleSwitch} from "../../customviews/switch";

const width = typeExport.WIDTH;
const height = typeExport.HEIGHT;
let Main = null
let content = null
export default class MenuDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: ["1", "2", "3"],
            switchValue: false,

            pending: false,
            success: false,
            error: '',

            backClickCount: 0,

            isOnBlueToggleSwitch: false,
        };
        content = this;
        this.springValue = new Animated.Value(100);
        // Main = new MainScreen();

    }


    closeDrawer() {
        this.props.navigation.toggleDrawer()

        //    this.props.navigation.toggleRightDrawer()
    }

    componentWillMount() {
        BackHandler.addEventListener('hardwareBackPress', this.handleBackButton);
    }

    componentWillUnmount() {
        BackHandler.removeEventListener('hardwareBackPress', this.handleBackButton);

    }

    _spring() {
        this.setState({backClickCount: 1}, () => {
                /*     ParentScreen.ShowMessageBack(),
                         setTimeout(function () {
                             content.setState({backClickCount: 0});
                             // alert("df")
                         }, 1000)*/

            }
        )
        // this.setState({backClickCount: 1}, () => {
        //     ParentScreen.ShowMessageBack(),
        //         Animated.sequence([
        //             [
        //                 Animated.spring(
        //                     this.springValue,
        //                     {
        //                         toValue: -.15 * height,
        //                         friction: 5,
        //                         duration: 1000,
        //                         useNativeDriver: true,
        //                     }
        //                 ),
        //                 Animated.timing(
        //                     this.springValue,
        //                     {
        //                         toValue: 100,
        //                         duration: 1000,
        //                         useNativeDriver: true,
        //                     }
        //                 ),
        //
        //             ]
        //
        //         ]).start(() => {
        //             this.setState({backClickCount: 0});
        //         });
        // });

    }

    handleBackButton = () => {
        // let routes = this.props.route.routes[0].routes[0].routes


        /*   if (this.props.route.isDrawerOpen) {
               this.props.navigation.closeDrawer()
           } else {
           /!*    if (routes.length > 1) {
                   this.props.navigation.pop()
               } else {

                   if (routes[0].routeName == "MainScreen") {
                       if (Tools.CheckRoutes(this.props.route.routes[0].routes, 'LoginStack') !== undefined && this.props.route.routes[0].routes.length > 1) {
                           this.props.navigation.pop()

                       } else
                           this.state.backClickCount == 1 ? BackHandler.exitApp() : (this._spring())

                       // if (routes.length > 1)
                       //     this.props.navigation.pop()
                       // this.props.navigation.navigate(nameRouter, data);
                       //BackHandler.exitApp()
                       /!*  if (routes.length  == 0)
                         {
                             this.state.backClickCount == 1 ? BackHandler.exitApp() : (this._spring())

                         }
                         else
                         {

                             this.props.navigation.pop()

                         }*!/
                   } else {

                       this.props.navigation.popToTop()
                       // NavigationService.navigatereset("MainScreen");
                       // NavigationService.PopToPop();
                       // NavigationService.navigateParams("MainScreen");
                   }
               }*!/
           }*/


        // return true;

    };

    async componentDidMount() {

        /*   const dispatchConnected = isConnected => this.props.callserviceActionConnection(isConnected);

           NetInfo.isConnected.fetch().then().done(() => {
               NetInfo.isConnected.addEventListener('connectionChange', dispatchConnected);
           });*/

    }


    componentWillReceiveProps(props) {
    }


    setData() {
        let token = this.props.DataSplashScreen.token
        // this.props.callService(typeExport.urlMenuDrawer, `?notify_status=${this.state.switchValue}&token=${token}`, typeExport.TypeSetMenuDrawer, 'POST', token)
        // this.props.callService(urlGetAllData, `?lang=fa&token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOlwvXC8xOTIuMTY4LjEuNDo4MDAwXC9hcGlcL2xvZ2luIiwiaWF0IjoxNTYxMzg4ODMwLCJleHAiOjE1NjEzOTI0MzAsIm5iZiI6MTU2MTM4ODgzMCwianRpIjoiSUlaWHZhdGVibjdFWXVzRCIsInN1YiI6MywicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSJ9.o0KBrCIT25CGALibOQwiomiDzVVX7D9ensRGPsOCznY`, TypeGetAllData, 'POST', token)

    }

    toggleSwitch = (value) => {
        //onValueChange of the switch this function will be called
        this.setState({switchValue: value},
            () => {
                this.setData()

            }
        )

        //Tools.Request(typeExport.POST, "", '', '', '', this.setState({switchValue: value,success:true,result}), '')
        //state changes according to switch
        //which will result in re-render the text
    }

    render() {
        //  let routes = this.props.route.routes[0].routes[0].routes
        let routes = "";
        // let CH=this.props.navigation.routes[0].routes[0].routes.find((element) => {
        //     return element.routeName === item.id
        // })
        let store_data = store.getState().reducerSplashGetAllData;

        let checkLogin = (store_data.TypeLogin == 2)


        let DataSplashScreenSaina = checkLogin ? (store_data.resultsShahrdar ? store_data.resultsShahrdar.result : null) : (store_data.resultsSaina ? store_data.resultsSaina.result : null)

        return (
            <View style={styles.container}>
                <ScrollView>

                    {/*<HMItem icon={"md-person"} onPress={() => NavigationService.navigateParams("ProductList")} text={}/>*/}
                    <View
                        style={{
                            backgroundColor: Colors.colorPrimary,
                            height: moderateScale(70),
                            padding: moderateScale(8),

                            justifyContent: "center",
                            //    alignItems: "center"
                        }}>

                        <View
                            style={{
                                backgroundColor: Colors.colorPrimary,
                                //  padding: moderateScale(8),
                                flexDirection: 'row',
                                // //justifyContent: "flex-end",
                                justifyContent: "space-between",
                                //  justifyContent: "flex-end",
                                marginTop: Platform.OS === 'ios' ? typeExport.HeightStatusBar : 0
                            }}>
                            <View
                                style={{
                                    backgroundColor: Colors.colorPrimary,
                                    //  padding: moderateScale(8),
                                    flexDirection: 'row',
                                    // //justifyContent: "flex-end",
                                    alignItems: "center",
                                    //  justifyContent: "flex-end",
                                    marginTop: Platform.OS === 'ios' ? typeExport.HeightStatusBar : 0
                                }}>
                                <HMIcon name={"md-person"} style={{
                                    color: 'white',
                                    // backgroundColor:'#eea900'
                                    //textAlign: 'center',
                                    //  alignSelf: 'center'

                                }}/>

                                <View style={{width: moderateScale(10)}}/>
                                {
                                    store_data.token ?
                                        <HMTextView
                                            text={store_data.user ? store_data.user.name + " " + store_data.user.family : ''}
                                            style={{
                                                color: Colors.white,
                                                fontSize: moderateScale(14),

                                                //  backgroundColor:'#ee0042'
                                                //textAlign: 'center',
                                                //alignSelf: 'center'
                                            }}
                                            //styleRoot={{alignSelf: "end"}}
                                        />
                                        :
                                        <TouchableOpacity
                                            onPress={() => {

                                                store.dispatch(serviceActionSetState({type: "MainScreen"}))
                                                // NavigationService.navigateParams('LoginEnterPhoneScreen')
                                                NavigationService.navigateParams('LoginStackScreen')

                                            }}
                                            style={{
                                                width: moderateScale(120),
                                                height: moderateScale(28),
                                                backgroundColor: Colors.white,
                                                borderRadius: moderateScale(6),
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                            <HMTextView
                                                type={'bold'}
                                                text={i18n.t('constant.Login')} style={{
                                                color: Colors.colorPrimary,
                                                fontSize: moderateScale(11),
                                                //  backgroundColor:'#ee0042'
                                                //textAlign: 'center',
                                                //alignSelf: 'center'
                                            }}/>
                                        </TouchableOpacity>


                                }


                            </View>
                            {
                                1 === 1 ?
                                    null
                                    :
                                    <ToggleSwitch
                                        // styleRoot={{alignSelf: "end"}}
                                        label={this.state.isOnBlueToggleSwitch ? "تاریک" : "روشن"}
                                        labelBold={"bold"}
                                        // labelStyle={{color:this.state.isOnBlueToggleSwitch ? "#fff" :"#eee" }}
                                        labelStyle={{color: this.state.isOnBlueToggleSwitch ? "#fff" : "#fff"}}
                                        // label={"متصل شدن خودکار به هات اسپات " + NameHotspot + " زمانی که که اپلیکیشن بسته است"}
                                        onColor={"rgb(0, 96, 96)"}
                                        isOn={this.state.isOnBlueToggleSwitch}
                                        onToggle={isOnBlueToggleSwitch => {
                                            this.setState({isOnBlueToggleSwitch});


                                            if (this.state.isOnBlueToggleSwitch) {
                                                Colors.colorPrimary = "#1D84C7";
                                                Colors.colorPrimaryDark = "#1461AB";
                                                Colors.colorSecondPrimary = "#4f9640";
                                                Colors.backgroundColor = "#FAFAFA";
                                                Colors.blackLight = "#262626";

                                                store.dispatch(serviceActionSetNameDynamic("ColorsProps",
                                                    {
                                                        colorPrimary: "#1D84C7",
                                                        colorPrimaryDark: "#1461AB",
                                                        colorSecondPrimary: "#4f9640",
                                                        backgroundColor: "#FAFAFA",
                                                        blackLight: "#262626",
                                                    }
                                                ))

                                            }
                                            else {
                                                Colors.colorPrimary = "#1d1d1d";
                                                Colors.colorPrimaryDark = "#000000";
                                                Colors.colorSecondPrimary = "#d2ad3c";
                                                Colors.backgroundColor = "#1d1d1d";
                                                Colors.backgroundColor = "#262626";
                                                Colors.blackLight = "#FAFAFA";
                                                store.dispatch(serviceActionSetNameDynamic("Colors",
                                                    {
                                                        colorPrimary: "#1d1d1d",
                                                        colorPrimaryDark: "#000000",
                                                        colorSecondPrimary: "#d2ad3c",
                                                        backgroundColor: "#262626",
                                                        blackLight: "#FAFAFA",
                                                    }
                                                ))


                                            }
                                        }}
                                    />
                            }

                        </View>
                        {/*<View style={{
                            backgroundColor: Colors.colorPrimary,
                            //  padding: moderateScale(8),
                            flexDirection: 'row',
                            width: '100%',
                            // //justifyContent: "flex-end",
                            alignItems: "center"
                        }}>
                            <HMTextView text={i18n.t('ChangeLanguage.notification')} style={{
                                color: Colors.white,
                                fontSize: moderateScale(18),
                                textAlign: 'center',
                                alignSelf: 'center'
                            }}/>

                            <View style={{flex: 1}}/>
                            <Switch
                                style={{transform: [{scaleX: Platform.OS === 'ios' ? .6 : .9}, {scaleY: Platform.OS === 'ios' ? .6 : .9}]}}
                                // style={{marginTop:30}}
                                onValueChange={this.toggleSwitch}
                                // value={this.state.switchValue}
                               // value={this.props.DataSplashScreen.results.user.notify_status == 1}
                                value={true}
                            />
                        </View>*/}
                    </View>

                    <View style={{flex: 1, marginTop: moderateScale(6)}}>

                        <HMItem icon={"home"} text={i18n.t('MenuDrawer.home')} navigateParams={() => {

                            //  if(this.props.route.routeName!="Drawer")
                            //   NavigationService.navigatereset('MainScreen');
                            this.closeDrawer()
                            NavigationService.PopToPop();
                            //  NavigationService.navigatereset('MainStack');
                            //NavigationService.navigate('ChangePassScreen');
                            // NavigationService.navigate('LoginStack');
                        }}/>
                        {
                            checkLogin || typeExport._TypeApp == "125" ?
                                null
                                :
                                <HMItem icon={"user"} text={i18n.t('constant.My_profile')} navigateParams={() => {
                                    this.ChangeDrawer(routes, "ProfileScreen", null, 'login')

                                    /* if (store_data.token != null) {

                                         NavigationService.navigateParams('ProfileStack')

                                     } else {
                                         store.dispatch(serviceActionSetState({type: "ProfileStack"}))

                                         NavigationService.navigateParams('LoginStack')

                                     }*/
                                }}/>
                        }

                        {
                            typeExport._TypeApp == "125" ?
                                null
                                :

                                <HMItem icon={"building"} text={i18n.t('constant.Municipality_Portal')}
                                        navigateParams={() => {
                                            //  Tools.GoLink("http://ahvaz.ir/")
                                            //   Tools.GoLink(typeExport.UrlPortal)
                                            //   alert(this.props.DataSplashScreen.resultsSaina)
                                            Tools.GoLink(DataSplashScreenSaina.info.portal)

                                        }}/>
                        }
                        <HMItem icon={"info-circle"} text={i18n.t('constant.About_software')} navigateParams={() => {
                            //    this.props.navigation.navigate("SatiaScreen", {type: 1});

                            //    this.props.navigation.navigate("MessagesSell", {type: 1});
                            //   NavigationService.navigatereset("MessagesSell", {type: 2});
                            if (checkLogin) {
                                this.ChangeDrawer(routes, "AboutUsScreen");
                            }
                            else
                                switch (typeExport._NameApp) {
                                    case "Ahvaz" :
                                        this.ChangeDrawer(routes, "ShahrbanSatiaScreen");

                                        break;
                                    case "Kerman" :
                                        this.ChangeDrawer(routes, "AboutUsScreen");
                                        break;
                                    default :
                                        this.ChangeDrawer(routes, "SatiaScreen")

                                }
                            // typeExport._NameApp == "Ahvaz" ?
                            //     this.ChangeDrawer(routes, "ShahrbanSatiaScreen")
                            //     :
                            //     this.ChangeDrawer(routes, "SatiaScreen")

                        }}/>

                        {
                            typeExport._NameApp == "Ahvaz" ?

                                <HMItem icon={"wpforms"} text={i18n.t('constant.Poll')} navigateParams={() => {

                                    // this.ChangeDrawer(routes, "PollScreen")
                                    this.ChangeDrawer(routes, "PollScreen", null, 'login')
                                }}/>
                                : null
                        }

                        {/*    <HMItem icon={"language"} text={i18n.t('constant.language')} navigateParams={() => {
                            //  NavigationService.navigatereset('ChangeLanguageScreen');
                            //this.props.navigation.popToTop();
                            // this.props.navigation.navigate("ChangeLanguageScreen");
                            // NavigationService.navigatereset("ChangeLanguageScreen");
                            this.ChangeDrawer(routes, "ChangeLanguageScreen")
                        }}/>*/}

                        {
                            typeExport._TypeApp == "125" ?

                                <HMItem typeIcon={"MaterialIcons"} icon={"settings"}
                                        text={i18n.t('constant.WeberviceSettings')} navigateParams={() => {

                                    // this.ChangeDrawer(routes, "PollScreen")
                                    this.ChangeDrawer(routes, "WebServiceScreen", null, null)
                                }}/>
                                : null
                        }

                        {/*{*/}
                        {/*typeExport._TypeApp == "125" ?*/}

                        {/*<HMItem typeIcon={"MaterialIcons"} icon={"rotate-right"} text={i18n.t('constant.ScreenRotation')}*/}
                        {/*navigateParams={() => {*/}
                        {/*Orientation.getOrientation((err, orientation) => {*/}
                        {/*if (orientation === 'PORTRAIT') {*/}
                        {/*Orientation.lockToLandscape();*/}
                        {/*} else {*/}
                        {/*Orientation.unlockAllOrientations();*/}
                        {/*Orientation.lockToPortrait();*/}
                        {/*}*/}
                        {/*});*/}
                        {/*}}/>*/}
                        {/*: null*/}
                        {/*}*/}
                        {
                            Platform.OS === "web" ?
                                null
                                :
                                <HMItem icon={"sign-out"} text={i18n.t('constant.Exit_the_app')} navigateParams={() => {


                                    BackHandler.exitApp()
                                }}/>
                        }


                    </View>

                </ScrollView>
                <View style={{width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                    {/*<Animated.View style={[styless.animatedView, {transform: [{translateY: this.springValue}]}]}>*/}
                    {/*<Text style={styless.exitTitleText}>press back again to exit the app</Text>*/}

                    {/*<TouchableOpacity*/}
                    {/*activeOpacity={0.9}*/}
                    {/*onPress={() => BackHandler.exitApp()}*/}
                    {/*>*/}
                    {/*<Text style={styless.exitText}>Exit</Text>*/}
                    {/*</TouchableOpacity>*/}

                    {/*</Animated.View>*/}
                    <TouchableOpacity
                        activeOpacity={1}

                        onPress={() => {
                            if (Platform.OS !== "web") {

                                if (Clipboard)
                                    Clipboard.setString(store_data.token_fb)
                            }
                        }}>
                        <HMTextView
                            text={i18n.t('constant.Version') + typeExport._Version}
                            //text={i18n.t('constant.Version') + DeviceInfo.getVersion()}

                            style={{
                                color: Colors.blackLight,
                                fontSize: moderateScale(14),
                                textAlign: 'center',
                                alignSelf: 'center'
                            }}/>
                    </TouchableOpacity>
                    {/*
                    <TouchableOpacity onPress={() => {
                    }} style={{
                        margin: moderateScale(4),
                        width: moderateScale(29),
                        height: moderateScale(29),
                    }}>
                        <Image source={require("../../assets/img/instageram1.png")}
                               style={{width: "100%", height: "100%",}}/>
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => {
                    }} style={{
                        margin: moderateScale(4),

                        width: moderateScale(29),
                        height: moderateScale(29),
                    }}>
                        <Image source={require("../../assets/img/telegram.png")}
                               style={{width: "100%", height: "100%",}}/>
                    </TouchableOpacity>


                    <TouchableOpacity onPress={() => {
                    }} style={{
                        margin: moderateScale(4),

                        width: moderateScale(29),
                        height: moderateScale(29),
                    }}>

                        <Image source={require("../../assets/img/whatsapp.png")}
                               style={{width: "100%", height: "100%",}}/>
                    </TouchableOpacity>*/}


                </View>

                {
                    this.props.isLoadingSet ?
                        <DialogLoadingCustomize/>
                        : null
                }
            </View>
        );
    }

    ChangeDrawer(routes, nameRouter, data, login, params) {

        if (login) {
            if (store_data.token != null) {
                this.goScreen(nameRouter, params)
                ///  NavigationService.navigatereset(nameRouter);
            } else {
                store.dispatch(serviceActionSetState({type: nameRouter}))
                /*   // if (Tools.CheckRoutes(routes, 'LoginEnterPhoneScreen') !== undefined && routes.length <= 1) {
                   if (Tools.CheckRoutes(routes, 'LoginEnterPhoneScreen') !== undefined && routes.length <= 1) {
                       //  alert("")
                       this.closeDrawer()

                   } else*/
                NavigationService.navigateParams('LoginStackScreen')
            }
        } else {
            //  NavigationService.navigatereset(nameRouter);
            this.goScreen(nameRouter, params)

        }

        /*     if (Tools.CheckRoutes(routes, store_data.token != null ? nameRouter : 'LoginEnterPhoneScreen') !== undefined) {
                 this.closeDrawer()
                 NavigationService.navigateParams(nameRouter)
             } else {
                 // if (routes.length > 1)
                 //     this.props.navigation.pop()
                 // this.props.navigation.navigate(nameRouter, data);
                 if (login) {
                     if (store_data.token != null) {
                         this.goScreen(nameRouter, params)
                         ///  NavigationService.navigatereset(nameRouter);
                     } else {
                         store.dispatch(serviceActionSetState({type: nameRouter}))
                         // if (Tools.CheckRoutes(routes, 'LoginEnterPhoneScreen') !== undefined && routes.length <= 1) {
                         if (Tools.CheckRoutes(routes, 'LoginEnterPhoneScreen') !== undefined && routes.length <= 1) {
                             //  alert("")
                             this.closeDrawer()

                         } else
                             NavigationService.navigateParams('LoginEnterPhoneScreen')
                     }
                 } else {
                     //  NavigationService.navigatereset(nameRouter);
                     this.goScreen(nameRouter, params)

                 }

             }*/
    }

    goScreen(nameRouter, params) {
        //NavigationService.resetTo(nameRouter);
        //   NavigationService.navigatereset(nameRouter);
        NavigationService.navigateParams(nameRouter, params);

        /*try{
            NavigationService.navigatereset(nameRouter);
        }
        catch (e) {
            NavigationService.resetTo(nameRouter);
        }*/
    }
}
const styless = {
    container: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.white
    },
    animatedView: {
        width,
        backgroundColor: "#0a5386",
        elevation: 2,
        position: "absolute",
        bottom: 0,
        padding: 10,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row",
    },
    exitTitleText: {
        textAlign: "center",
        color: "#ffffff",
        marginRight: 10,
    },
    exitText: {
        color: "#e5933a",
        paddingHorizontal: 10,
        paddingVertical: 3
    }
};
